module.exports = __webpack_public_path__ + "img/logo.1ac3c382.png";